import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Alert, Button, Form, Input, Layout } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { loginApi } from 'common/api/entitiesApi'
import { StorageKey } from 'common/context/Storage'
import { useUserContext } from 'common/context/UserContext'
import { setLoggedUserProps } from 'common/util/Util'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import './style.css'

import * as routes from '../../pages/routes'

const FormItem = Form.Item

export const LoginForm: React.FC = () => {
  const formRef = useRef<FormInstance>(null)
  const [authError, setAuthError] = useState<string | null>(null)
  const { setUser, logoDataURI, customizationLoaded, agencyRecognized, advertiserSelfRegistration } = useUserContext()
  const navigateTo = useNavigate()

  const handleSubmit = () => {
    formRef.current?.validateFields().then((values) => {
      setAuthError(null)
      loginApi.login(values.username, values.password).then((success) => {
        if (success) {
          setLoggedUserProps(setUser).then(() => {
            navigateTo('/')
          })
        } else {
          setAuthError(localStorage.getItem(StorageKey.ApiError) || 'Incorrect Username or Password')
        }
      })
    })
  }

  if (!customizationLoaded) {
    return <div className="login-form" />
  }

  return (
    <Layout>
      {logoDataURI && (
        <div className="auth-logo-wrapper">
          <img src={logoDataURI} alt="Logo" className="auth-logo" />
        </div>
      )}
      <Form onFinish={handleSubmit} className="login-form" ref={formRef}>
        <Form.Item name="username" rules={[{ required: true, message: 'Please input your username!' }]}>
          <Input prefix={<UserOutlined />} placeholder="Username" />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
          <Input.Password prefix={<LockOutlined />} placeholder="Password" />
        </Form.Item>
        <FormItem>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Log in
          </Button>
        </FormItem>
        {agencyRecognized && advertiserSelfRegistration ? (
          <FormItem>
            <Button type="default" className="login-form-button" onClick={() => navigateTo(routes.SIGN_UP_ADVERTISER)}>
              Sign up
            </Button>
          </FormItem>
        ) : null}
        <FormItem>
          <Button type="default" className="login-form-button" onClick={() => navigateTo(routes.RESET_PASSWORD)}>
            Forgot your password?
          </Button>
        </FormItem>
        {authError ? <Alert message={authError} type="error" /> : null}
      </Form>
    </Layout>
  )
}
